export default "__VITE_ASSET__CgYjnNom__"